var e = { exports: {} };
export {
  e as j
};
//# sourceMappingURL=jsx-runtime2.js.map
